import { render } from "./ConfigurationSaveDialog.vue?vue&type=template&id=6c09df4a"
import script from "./ConfigurationSaveDialog.vue?vue&type=script&lang=js"
export * from "./ConfigurationSaveDialog.vue?vue&type=script&lang=js"

import "./ConfigurationSaveDialog.vue?vue&type=style&index=0&id=6c09df4a&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});qInstall(script, 'directives', {ClosePopup});
